import routes from "@/routes";
import { lazy } from "react";
const Integration = lazy(() => import("@/modules/integration"));
const ListIntegration = lazy(
  () => import("@/modules/integration/ListIntegration")
);
const ListOnboardingDistribution = lazy(
  () =>
    import("@/modules/OnboardingDistribution/ListOnboardingDistribution")
);

export default function IntegrationRoutes(
  canSeeOnboardingDistribution: boolean
) {
  return {
    element: <Integration />,
    path: "integrations",
    children: [
      {
        element: <ListIntegration />,
        path: "",
      },
      ...(canSeeOnboardingDistribution
        ? [
            {
              element: <ListOnboardingDistribution />,
              path: routes.ONBOARDING_DISTRIBUTION.INDEX,
            },
          ]
        : []),
    ],
  };
}
